import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
import SyncRequest from 'owa-service/lib/contract/SyncRequest';

export let resetEditAccountStore = mutatorAction(
    'resetEditAccountStore',
    (syncRequest: SyncRequest) => {
        let store = connectedAccountsStore();
        store.editAccountState.displayName = syncRequest.DisplayName;
        store.editAccountState.emailAddress = syncRequest.EmailAddress;
        store.editAccountState.isOAuthSync = syncRequest.IsOAuthSync;
        store.editAccountState.isSendOnly = syncRequest.IsSendOnly;
        store.editAccountState.username = syncRequest.UserName;
        store.editAccountState.incomingServer = syncRequest.RemoteServerName;
        store.editAccountState.incomingPort = syncRequest.RemoteServerPort.toString();
        store.editAccountState.syncProtocol = syncRequest.SyncProtocol;
        store.editAccountState.outgoingServer = syncRequest.SmtpServerName;
        store.editAccountState.outgoingPort = syncRequest.SmtpServerPort.toString();
        store.editAccountState.incomingAuth = syncRequest.AuthenticationMethod;
        store.editAccountState.incomingSecurity = syncRequest.SecurityMechanism;
        store.editAccountState.useAltUsernamePassword = !!syncRequest.SmtpUserName;
        store.editAccountState.altUsername = syncRequest.SmtpUserName;
        store.editAccountState.leaveCopy = syncRequest.LeaveOnServer;
        store.editAccountState.isErrorStatus =
            syncRequest.Status == 'Failed' || syncRequest.Status == 'Suspended';
    }
);
